import Add from './add/CanAddAppointmentInitialState'

const { Record } = require('immutable');

export default Record({
    add: Add()
});